<div class="container-fluid">
    <div class="row">
        <!-- sidemenu block start  -->
        <div class="col-12 col-lg-2 col-md-12">

            <app-sidebar #sidebar></app-sidebar>

        </div>
        <!-- sidemenu block end  -->

        <!-- content block start  -->
        <div class="col-md-10 mx-auto col-12 content-block" >

            <div class="container-row">
                <div class="container-col">

                    <button (click)="sidebar.toggleSidebar($event)" class="btn mobile-toggler md-none btn-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
                            <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2"/>
                            <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2"/>
                            <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2"/>
                          </svg>
                      </button>
                    <div class="content-block" (scroll)="onScroll($event)" #scrollContainer>
                        <app-work-play-toggle-tab></app-work-play-toggle-tab>
                        <div class="row">
                            <div class="offset-lg-1 col-lg-10 col-12">
                                <router-outlet></router-outlet>
                            </div>
                        </div>
                    </div>


                    <div class="question-block">
                        <button *ngIf="showScrollButton" (click)="scrollToBottom()" class="scroll-to-bottom-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24px" width="24px"><path fill="currentColor" d="M11 4h2v12l5.5-5.5l1.42 1.42L12 19.84l-7.92-7.92L5.5 10.5L11 16z"/></svg>
                        </button>
                        <div class="row">
                            
                            <div *ngIf="isPlayMode()" class="offset-lg-1 col-lg-10 col-12">
                                <app-option-style></app-option-style>
                                <div class="row">
                                    <div class="col-12 text-end mb-2 px-3">
                                        <app-prompt-list></app-prompt-list>
                                    </div>
                                </div>
                                <div class="row px-3">
                                    <div class="col-12">
                                        <app-chat-textarea></app-chat-textarea>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-disclaimer-msg></app-disclaimer-msg>
        </div>
        <!-- content block end  -->
         
    </div>
</div>